module.exports = __webpack_public_path__ + "772a38ea5749e4aa66520854724a88ce.jpg";